import { withStyles } from '@material-ui/core/styles'
import React from 'react'

const enhance = withStyles(() => ({
  wrapper: {
    padding: 0,
    '& li': {
      padding: '8px 16px',
      height: 72,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      animation: 'flickerAnimation 2s infinite',
      '& > div:first-child': {
        width: 60,
      },
      '& > div:nth-child(2)': {
        width: '100%',
      },
    },
  },
  line: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:not(:first-child)': {
      marginTop: 8,
    },
    '&:first-child div': {
      height: 14,
    },
    '& div': {
      height: 8,
      background: '#ccc',
      marginRight: 8,
      borderRadius: 8,
      width: '100%',
    },
  },
  ball: {
    width: 40,
    height: 40,
    background: '#ccc',
    borderRadius: '50%',
  },
  '@keyframes flickerAnimation': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.5 },
    '100%': { opacity: 1 },
  },
}))

function Item({ classes }) {
  return (
    <li>
      <div>
        <div className={classes.ball} />
      </div>
      <div>
        <div className={classes.line} style={{ width: '70%' }}>
          <div />
          <div />
        </div>
        <div className={classes.line} style={{ width: '60%' }}>
          <div />
          <div />
        </div>
      </div>
    </li>
  )
}

function Placeholder({ classes }) {
  return (
    <ul className={classes.wrapper}>
      {[1, 2, 3, 4, 5, 6].map((key) => (
        <Item classes={classes} key={key} />
      ))}
    </ul>
  )
}

export default enhance(Placeholder)
